import { plantSheetFileName, plantSheetPath } from '../../domain/plants/plantSheet';
import { fetchShareImageFile } from './shareImageFile';

/**
 * Load a plant's pre-rendered sheet as a `File`, ready for the share sheet
 * (SPEC-005).
 *
 * The fetch itself moved to `shareImageFile.js` when the app gained an
 * invitation card of its own (SPEC-020 D-5) — none of it was ever about plants.
 * What is left here is the part that is: which file this plant's sheet is, and
 * what it is called when it travels.
 *
 * The language arrived with SPEC-005 D-14, when the sheet stopped being one
 * English page and became one per shipped language. Anything unrendered resolves
 * to English inside `plantSheetPath`, so a caller that does not know the
 * language still gets a sheet rather than a 404.
 *
 * The options object is passed straight through, so this keeps the defaulted
 * `fetchImpl` / `timeoutMs` / `FileImpl` seams its callers and tests already use.
 */

export async function fetchPlantSheetFile({ plantId, commonName, languageCode }, options = {}) {
    return fetchShareImageFile(
        {
            url: plantSheetPath(plantId, languageCode),
            fileName: plantSheetFileName(commonName),
            type: 'image/jpeg',
        },
        options,
    );
}
